module.exports = __webpack_public_path__ + "img/czechia-logo-icon.8b933261.png";